"use client";

import React from "react";

interface MindalooEmblemProps {
  size?: number;
  className?: string;
  isPremiumGodMode?: boolean;
}

/** Karma infinity knot — breathing autonomous consciousness emblem */
export default function MindalooEmblem({
  size = 96,
  className = "",
  isPremiumGodMode = false,
}: MindalooEmblemProps) {
  const accent = isPremiumGodMode ? "#9333EA" : "#C1A2FF";

  return (
    <div
      className={`relative flex items-center justify-center ${className} ${
        isPremiumGodMode
          ? "drop-shadow-[0_0_15px_rgba(147,51,234,0.5)]"
          : ""
      }`}
      style={{ width: size, height: size }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 100 100"
        fill="none"
        className="w-full h-full animate-pulse"
        aria-hidden
      >
        <path
          d="M25 10 L50 35 L75 10 L90 25 L65 50 L90 75 L75 90 L50 65 L25 90 L10 75 L35 50 L10 25 Z"
          stroke={accent}
          strokeWidth="6"
          strokeLinejoin="round"
          fill={`${accent}22`}
          style={{
            filter: isPremiumGodMode
              ? "drop-shadow(0 0 12px rgba(147,51,234,0.8))"
              : "drop-shadow(0 0 8px rgba(193,162,255,0.5))",
          }}
        />
      </svg>
    </div>
  );
}
